<template>
  <div class="about">
    <div><p style="text-align: right;">{{shop}}</p></div>
    <h1>Bundles</h1>
    <section>
      <p><strong>A Bundle Group</strong> allows you to select a parent (master) product and all its child (component) products.  When a parent product is sold, each one of its child products will be decreased by a quantity you can specify.</p>
      <p>For example, you can setup a Camera Kit (master product).  Within the Kit it has the following compoents 1 x Camera; 2 x Lens; 1 x Tripod. When a Camera Kit is sold, the app will decrease 1 camera, 2 lenses, and 1 tripod from inventory quantity.</p>
    </section>
    <v-expansion-panel>
      <v-expansion-panel-content v-for="(item,i) in 1" :key="i">
        <div slot="header" style="color:red">Video Tutorial: How to setup bundle group (Click to watch)</div>
        <v-card>
          <v-card-text><iframe width="800" height="451" src="https://www.youtube.com/embed/9qsAmbduV70" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <br>
    <v-alert style="margin-bottom: 10px" :value="true" color="info" icon="info" outline>
      Need a bit of help?  Contact us: <a href="mailto:support@inscoder.com">support@inscoder.com</a>
    </v-alert>
    <hr v-if="!loading">
    <v-layout v-if="loading" align-center justify-center row fill-height>
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-layout>

    <section v-if="!loading && mode=='groups-listing'">
      <v-layout v-if="bundlegroup" align-center justify-space-between row>
        <p>This feature is currently turned on. Click the "<strong>Disable</strong>" button to stop using it.</p>
        <p><v-btn large color="primary" v-on:click="disableModeEnabled = true">Delete All</v-btn></p>
      </v-layout>
      <v-layout v-else align-center justify-space-between row>
        <p>This feature is currently turned off. Click the "<strong>Enable</strong>" button to begin using it.</p>
        <p><v-btn large color="primary" v-on:click="enableBundlegroup">Enable</v-btn></p>
      </v-layout>
    </section>

    <section v-if="!loading && bundlegroup && mode=='groups-listing'">
      <v-layout v-if="scanning" align-center justify-center row fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>

      <v-btn v-if="!scanning" style="text-transform: none" block large color="primary" @click="() => { this.mode = 'group-creating'; initNewGroup(); searchProducts(true, true) }"><v-icon small>add</v-icon> Create a new Bundle Group</v-btn>

      <v-card v-if="!errored && !scanning">
        <v-card-title>
          <b>Groups</b>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="sku_groups"
          :pagination.sync="pagination"
          class="elevation-1"
          :search="search"
        >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">
              <a @click="() => { editGroup(props.item.gid.domain, props.item.gid.id) }" style="margin-right: 20px">Edit Bundle | Inventory</a>
              <a @click="() => { openDeleteGroupDialog(props.item.gid.id) }">Delete</a>
            </td>
          </template>
        </v-data-table>
      </v-card>

    </section>

    <section v-if="mode=='group-creating'">
      <v-layout align-center justify-space-between row>
        <h2>Edit Bundle Group</h2>
        <p>
          <v-btn v-if="current_group_id!=0" large color="link" @click="() => {openLink(groupViewEditUrl)}" :disabled="savingGroup">Edit Inventory</v-btn>
          <v-btn v-if="current_group_id!=0" large color="link" @click="() => {openDeleteGroupDialog(this.current_group_id)}" :disabled="savingGroup">Delete Bundle</v-btn>
          <v-btn large color="primary" v-on:click="closeGroupView">Back to Bundles</v-btn>
        </p>
      </v-layout>

      <v-layout v-if="bundlegroup" align-center justify-space-around row>
        <v-text-field
          label="Bundle Name"
          v-model="group_name"
          placeholder="Enter a Bundle Name (for example: Base T-Shirt White)"
          single-line
          solo
        >
        </v-text-field>
        <!--v-btn v-if="group_name == '' || !hasMaster" style="top:-14px" disabled large color="primary">Save</v-btn-->
        <v-btn style="top:-14px" large color="primary" :disabled="savingGroup" v-on:click="saveGroup">Save</v-btn>
      </v-layout>

      <v-layout v-if="bundlegroup" align-top justify-space-around row>
        <v-card style="width: 30%">
          <div style="padding: 20px">
            <v-text-field
              v-model="pKeyword"
              label="Search Products"
              placeholder="Type the product title to search"
            ></v-text-field>
            <v-layout v-if="searching" align-center justify-center row fill-height>
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-layout>
          </div>

          <v-expansion-panel v-if="!searching" style="box-shadow: none">
            <v-expansion-panel-content
              class="searched-product"
              v-for="(item,i) in searchedProducts"
              :key="i"
            >
              <div class="searched-product-title" slot="header">
                <img v-if="item.image" :src="item.image.src"><img v-if="!item.image" src="../assets/noimage.jpg"><strong>{{item.title}}</strong>
              </div>
              <div class="searched-product-variants">
                <v-layout class="variant" v-for="(v,j) in item.variants" align-center justify-space-between row>
                  <div class="searched-variant-title" slot="header">
                    <strong v-if="item.variants.length > 1">{{v.title}}</strong> <span class="sku" v-if="v.sku"> {{v.sku}}</span><span class="sku" v-else> <i>(No sku)</i></span>
                  </div>
                  <span v-if="!variantAdded(v.id)" class="add" @click="() => { addVariant(i, j) }">Add</span>
                  <span v-else class="added">Added</span>
                </v-layout>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-layout align-center justify-center row>
            <div class="text-xs-center">
              <v-btn v-if="previousPageInfo" fab small @click="() => { searchProducts(false) }">
                <v-icon dark>arrow_back</v-icon>
              </v-btn>
              <v-btn v-else disabled fab small>
                <v-icon dark>arrow_back</v-icon>
              </v-btn>
              <v-btn v-if="nextPageInfo" fab small @click="() => { searchProducts(true) }">
                <v-icon dark>arrow_forward</v-icon>
              </v-btn>
              <v-btn v-else disabled fab small>
                <v-icon dark>arrow_forward</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-card>

        <div class="added-products" style="width: 70%;">
          <h4 class="headline">Search and add products or variants to this group. Select one item as the parent (master).  For all other items, specify the inventory quantity of each component that makes up the bundle.  When you’re done, click the <strong>Save</strong> button. </h4>

          <v-checkbox
              v-model="auto_update_master"
              primary
              hide-details
              style="display: none"
          >
            <div slot="label" style="color: #333">
              Auto update the <strong>Master’s</strong> inventory
            </div>
          </v-checkbox>

          <div class="added-products-container">
            <v-layout class="variant" v-for="(v,i) in addedVariants" align-center justify-space-between row>
              <div class="added-variant-title" slot="header">
                <a v-if="v.variant_link && v.variant_link !== null" target="_blank" :href="`${v.variant_link}`"> <strong>{{v.shopify_product_title}}</strong> {{ v.shopify_variant_title }}</a>
                <span> | </span>
                <a v-if="v.inventory_link && v.inventory_link !== null" target="_blank" :href="`${v.inventory_link}`">(view inventory history)</a>
              </div>
              <div>
                <span v-if="v.bundle_role != 'master'" class="select-master" @click="() => { setMaster(v.shopify_variant_id) }">Set as Master</span>
                <span v-else class="master">Bundle Master</span>
                <label v-if="v.bundle_role != 'master'" style="margin-right: 10px; margin-left: 20px;">Items (per bundle): <input class="spin-visible" style="width: 58px" type="number" min="1" v-model="v.component_inventory_quantity" oninput="validity.valid||(value=1)"></label>
                <label v-else style="margin-right: 10px; margin-left: 20px;"></label>
                <span class="remove" @click="() => { removeVariant(v.shopify_variant_id) }">Remove</span>
              </div>
            </v-layout>
          </div>
        </div>

      </v-layout>
      <div>
        <br />
        <br />
        <br />
      </div>
    </section>

    <v-layout v-if="deleteDialogEnabled" row justify-center>
      <v-dialog v-model="deleteDialogEnabled" persistent max-width="390">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card>
          <v-card-title class="headline">Are you sure about removing this group?</v-card-title>
          <v-card-text>This action can not be reverted.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="deleteDialogEnabled = false; ">No</v-btn>
            <v-btn color="green darken-1" flat @click.native="deleteDialogEnabled = false; deleteGroup()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout v-if="disableModeEnabled" row justify-center>
      <v-dialog v-model="disableModeEnabled" persistent max-width="390">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text>
            All the groups will be deleted upon disabled. This action cannot be recovered.<br>
            <br>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="disableModeEnabled = false; disableBundlegroup()">Permanently Delete</v-btn>
            <v-btn color="green darken-1" flat @click.native="disableModeEnabled = false; ">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout v-if="duplicateEnabled" row justify-center>
      <v-dialog v-model="duplicateEnabled" persistent max-width="500">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card>
          <v-card-title class="headline">Duplicate this bundle?</v-card-title>
          <v-card-text><p>Provide a name for your new bundle</p>
            <v-text-field
                label="Bundle Name"
                v-model="duplicateGroupName"
                placeholder="Enter a Bundle Name (for example: Base T-Shirt White)"
                single-line
                solo
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="duplicateEnabled = false; ">Cancel</v-btn>
            <v-btn color="green darken-1" flat @click.native="duplicateEnabled = false; duplicateGroup()" :disabled="!duplicateGroupName">Duplicate</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout v-if="savingAlert" row justify-center>
      <v-dialog v-model="savingAlert" persistent max-width="390">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card>
          <v-card-title class="headline">Can not save the bundle</v-card-title>
          <v-card-text>
            <ul>
              <li v-if="group_name == ''">Bundle name is empty</li>
              <li v-if="!hasMaster">Bundle must have a master product</li>
              <li v-else> {{ savingAlertMsg }}</li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="savingAlert = false;">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

  </div>
</template>

<script>
import axios from 'axios'
import {globalStore} from '../main.js'
import _debounce from 'lodash/debounce'

export default {
  computed: {
    count () {
      return this.$store.state.count
    },
    loading () {
      this.checkStatus
      this.checkInventoryLevels
      return this.checkStatus || this.checkInventoryLevels
    },
    hasMaster () {
      let result = false
      this.addedVariants.forEach(function(a){
        if (a.bundle_role && a.bundle_role == 'master') {
          result = true
        }
      })
      return result
    }
  },
  created: function () {

  },
  data () {
    return {
      shop: this.$store.state.shop,
      pagination: {
        sortBy: 'name'
      },
      sku_groups: [],
      bundlegroup: false,
      savingAlert: false,
      savingAlertMsg: '',
      scanning: true,
      checkStatus: true,
      checkInventoryLevels: true,
      auto_update_master: false,
      mode: 'groups-listing',
      changingMode: false,
      errored: false,
      groupViewEditUrl: '',
      checkStatusInterval: null,
      pKeyword: '',
      previousPageInfo: null,
      nextPageInfo: null,
      searching: false,
      current_group_id: 0,
      group_id_to_be_deleted: 0,
      group_name: '',
      searchedProducts: null,
      location: null,
      loadingLocation: true,
      allLocations: [],
      checkInventoryLevels: true,
      inventoryLevels: [],
      addedVariants: [],
      savingGroup: false,
      deleteDialogEnabled: false,
      disableModeEnabled: false,
      duplicateEnabled: false,
      duplicateGroupName: '',
      domain: null,
      search: '',
      headers: [
        {
          text: 'Bundle Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Actions', align: 'right', value: 'gid', sortable: false }
      ],
      groupHeaders: [
        {
          text: 'Product / Variant',
          align: 'left',
          sortable: true,
          value: 'title'
        },
        { text: 'SKU', align: 'left', value: 'sku', sortable: false }
      ],
    }
  },
  filters: {
    currencydecimal (value) {
      return value.toFixed(2)
    }
  },
  watch: {
    pKeyword: function() {
      this.debounceSearchProducts(true,true)
    }
  },
  mounted () {
    axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.$store.getters.code

    this.checkBundlegroupStatus()
    this.doCheckInventoryLevels()

  },
  methods: {

    doCheckInventoryLevels () {
      if (globalStore.inventoryLevels != null) {
        this.inventoryLevels = globalStore.inventoryLevels
        this.checkInventoryLevels = false
      } else {
        let check_inventory_url = 'https://' + this.$store.getters.engine + '/api/location/search'

        this.checkInventoryLevels = true

        this.inventoryLevels = []
        let ILVs = this.inventoryLevels

        axios
          .get(check_inventory_url)
          .then(response => {
            response.data.body.data.locations.edges.forEach(function(e){
              e.node.inventoryLevels.edges.forEach(function(edge){
                let inventoryGID = edge.node.id.split('?')[0].split('/')
                ILVs.push(inventoryGID[inventoryGID.length-1])
              })
            })
            globalStore.inventoryLevels = ILVs
          })
          .catch(error => {
            this.errored = true
            console.log(error)
          })
          .finally(() => {
            this.checkInventoryLevels = false
          })
      }
    },

    initNewGroup () {
      this.pKeyword = ''
      this.current_group_id = 0
      this.group_name = ''
      this.addedVariants = []
    },

    searchProducts (next = true, refresh = false) {
      let url
      if (refresh) {
        this.previousPageInfo = null
        this.nextPageInfo = null
      }
      if (next) {
        url = `https://${this.$store.getters.engine}/api/products/search?title=${encodeURIComponent(this.pKeyword)}&limit=5&next_page_info=${encodeURIComponent(this.nextPageInfo || '')}`
      } else {
        url = `https://${this.$store.getters.engine}/api/products/search?title=${encodeURIComponent(this.pKeyword)}&limit=5&previous_page_info=${encodeURIComponent(this.previousPageInfo || '')}`
      }

      this.searchedProducts = null
      this.searching = true

      axios
        .get(url)
        .then(response => {
          this.searchedProducts = response.data.products
          this.previousPageInfo = (response.data.has_previous_page ? response.data.previous_page_info : null)
          this.nextPageInfo = (response.data.has_next_page ? response.data.next_page_info : null)
        })
        .catch(error => {
        })
        .finally(() => {this.searching = false})
    },

    addVariant (i, j) {
      this.addedVariants.push(
        {
          "shopify_product_id": this.searchedProducts[i].id,
          "shopify_product_title": this.searchedProducts[i].title,
          "shopify_variant_id": this.searchedProducts[i].variants[j].id,
          "shopify_variant_title": this.searchedProducts[i].variants[j].title,
          "inventory_item_id": this.searchedProducts[i].variants[j].inventory_item_id,
          "shopify_product_admin_graphql_api_id": this.searchedProducts[i].admin_graphql_api_id,
          "shopify_variant_admin_graphql_api_id": this.searchedProducts[i].variants[j].admin_graphql_api_id,
          "bundle_role": "component",
          "component_inventory_quantity": 1,
          "variant_link": `https://${this.$store.state.shop}/admin/products/${this.searchedProducts[i].id}/variants/${this.searchedProducts[i].variants[j].id}/`,
          "inventory_link": `https://${this.$store.state.shop}/admin/products/inventory/${this.searchedProducts[i].variants[j].inventory_item_id}/inventory_history`,
        }
      )
    },

    variantAdded (i) {
      for (let j=0;j<this.addedVariants.length;j++) {
        if (this.addedVariants[j].shopify_variant_id == i) {
          return true
        }
      }
      return false
    },

    removeVariant (i) {
      for (let j=0;j<this.addedVariants.length;j++) {
        if (this.addedVariants[j].shopify_variant_id == i) {
          this.addedVariants.splice(j, 1)
          break
        }
      }
    },

    setMaster (i) {
      for (let j=0;j<this.addedVariants.length;j++) {
        if (this.addedVariants[j].shopify_variant_id == i) {
          this.addedVariants[j].bundle_role = 'master'
          this.addedVariants[j].component_inventory_quantity = 0
        } else {
          this.addedVariants[j].bundle_role = 'component'
          this.addedVariants[j].component_inventory_quantity = this.addedVariants[j].component_inventory_quantity > 0 ? this.addedVariants[j].component_inventory_quantity : 1
        }
      }
    },

    saveGroup() {
      if (this.savingGroup) {
        return
      }
      if (this.group_name == '' || !this.hasMaster) {
        this.savingAlert = true
        return
      }
      if (this.current_group_id == 0) {
        let url = `https://${this.$store.getters.engine}/api/bundlegroup/create`
        this.savingGroup = true
        axios
          .post(url, {
            "group_name": this.group_name,
            "auto_update_master": this.auto_update_master,
            "variants": this.addedVariants
          })
          .then(response => {
            if (response.data && response.data.status === "failed") {
              this.savingAlert = true
              this.savingAlertMsg = response.data.message
              this.savingGroup = false
              return
            } else {
              this.mode = 'groups-listing'
              this.savingGroup = false
              this.scanGroups()
            }
          })
          .catch(error => {
            this.savingAlert = true
            this.savingGroup = false
          })
          .finally(() => {

          })
      } else {
        let url = `https://${this.$store.getters.engine}/api/bundlegroup/update`
        axios
          .post(url, {
            "id": this.current_group_id,
            "group_name": this.group_name,
            "auto_update_master": this.auto_update_master,
            "variants": this.addedVariants
          })
          .then(response => {
            if (response.data && response.data.status === "failed") {
              this.savingAlert = true
              this.savingAlertMsg = response.data.message
              return
            } else {
              this.mode = 'groups-listing'
              this.scanGroups()
            }
          })
          .catch(error => {
          })
          .finally(() => {
          })
      }
    },

    duplicateGroup () {
      if (this.savingGroup) {
        return
      }

      let url = `https://${this.$store.getters.engine}/api/bundlegroup/create`
      this.savingGroup = true
      axios
        .post(url, {
          "group_name": this.duplicateGroupName,
          "auto_update_master": this.auto_update_master,
          "variants": this.addedVariants
        })
        .then(response => {
          let id = response.data.id
          url = 'https://' + this.$store.getters.engine + '/api/bundlegroup'
          this.scanning = true
          axios
            .get(url)
            .then(response => {
              this.sku_groups = []
              response.data.forEach(g => {
                this.sku_groups.push({
                  value: g.id,
                  name: g.group_name,
                  sku: g.sku,
                  gid: {domain: g.shopify_domain, id: g.id}
                })
              })
              this.editGroup(this.domain, id)
            })
            .catch(error => {
              this.errored = true
            })
            .finally(() => {this.scanning = false})

        })
        .catch(error => {

        })
        .finally(() => {
          this.mode = 'groups-listing'
          this.savingGroup = false
        })
    },

    openDeleteGroupDialog (id) {
      if (id != 0) {
        this.group_id_to_be_deleted = id
        this.deleteDialogEnabled = true
      }
    },

    openDuplicateGroupDialog () {
      this.duplicateGroupName = 'Copy of ' + this.group_name
      this.duplicateEnabled = true
    },

    deleteGroup () {
      if (this.group_id_to_be_deleted != 0) {
        let url = `https://${this.$store.getters.engine}/api/bundlegroup/delete`
        axios
          .post(url, {
            "id": this.group_id_to_be_deleted
          })
          .then(response => {
          })
          .catch(error => {
          })
          .finally(() => {
            this.group_id_to_be_deleted = 0
            this.mode = 'groups-listing'
            this.scanGroups()
          })
      }
    },

    disableBundlegroup () {
      let url = 'https://' + this.$store.getters.engine + '/api/bundlegroup/status'

      this.mode = 'groups-listing'

      axios
        .post(url, {"bundlegroup": "disabled"})
        .then(response => {
          this.bundlegroup = false
        })
        .catch(error => {

        })
        .finally(() => {

        })
    },

    enableBundlegroup () {
      let url = 'https://' + this.$store.getters.engine + '/api/bundlegroup/status'

      axios
        .post(url, {bundlegroup: 'enabled'})
        .then(response => {
          if (response.data.status == 'success') {
            this.checkStatusInterval = setInterval(() => {
              this.checkBundlegroupStatus()
            }, 5000)
          }
        })
        .catch(error => {
        })
        .finally(() => {
        })
    },

    checkBundlegroupStatus () {
      this.checkStatus = true
      let url = 'https://' + this.$store.getters.engine + '/api/bundlegroup/status'

      axios
        .get(url)
        .then(response => {
          if (this.checkStatusInterval) {
            clearInterval(this.checkStatusInterval)
            this.checkStatusInterval = null
          }
          this.bundlegroup = (response.data.bundlegroup == 'enabled')
          if (this.bundlegroup) {
            this.scanGroups()
          }
        })
        .catch(error => {
        })
        .finally(() => {
          this.checkStatus = false
        })
    },

    scanGroups () {
      let url = 'https://' + this.$store.getters.engine + '/api/bundlegroup'

      this.scanning = true

      axios
        .get(url)
        .then(response => {
          this.sku_groups = []

          response.data.forEach(g => {
            this.sku_groups.push({
              value: g.id,
              name: g.group_name,
              sku: g.sku,
              gid: {domain: g.shopify_domain, id: g.id}
            })
          })

        })
        .catch(error => {
          this.errored = true
        })
        .finally(() => {this.scanning = false})
    },

    editGroup (domain, id) {
      if (this.changingMode) {
        return
      }
      this.changingMode = true
      this.pKeyword = ''
      this.searchPageIndex = 1
      this.searchNext = false
      this.searchPrev = false
      this.groupViewEditUrl = ''
      this.current_group_id = id
      this.domain = domain
      this.addedVariants = []

      this.sku_groups.forEach(g => {
        if (g.value == id) {
          this.group_name = g.name
          this.auto_update_master = g.auto_update_master
        }
      })


      let url = 'https://' + this.$store.getters.engine + '/api/bundlegroup/' + id
      let ILs = this.inventoryLevels

      axios
        .get(url)
        .then(response => {
          let vids = ''
          response.data.forEach(v => {
            vids += (vids == '' ? v.shopify_variant_id : ',' + v.shopify_variant_id)
            this.addedVariants.push(
              {
                "shopify_product_id": v.shopify_product_id,
                "shopify_product_title": v.shopify_product_title,
                "shopify_variant_id": v.shopify_variant_id,
                "shopify_variant_title": v.shopify_variant_title,
                "inventory_item_id": v.inventory_item_id,
                "shopify_product_admin_graphql_api_id": v.shopify_product_admin_graphql_api_id,
                "shopify_variant_admin_graphql_api_id": v.shopify_variant_admin_graphql_api_id,
                "bundle_role": v.bundle_role,
                "component_inventory_quantity": v.component_inventory_quantity,
                "inventory_link": `https://${domain}/admin/products/inventory/${v.inventory_item_id}/inventory_history`,
                "variant_link": `https://${domain}/admin/products/${v.shopify_product_id}/variants/${v.shopify_variant_id}/`
              }
            )
          })

          if (ILs.length <= -1) {
            this.groupViewEditUrl = `https://${domain}/admin/bulk?resource_name=ProductVariant&edit=inventory_quantity_adjustment,price&show=full_title,title,sku&ids=${vids}`
          } else {
            let inventoryLVs = ''
            ILs.forEach(function(lv) {
              inventoryLVs += ',inventory_levels.' + lv + '.available_adjustment'
            })
            this.groupViewEditUrl = `https://${domain}/admin/bulk?resource_name=ProductVariant&edit=price${inventoryLVs}&show=full_title,title,sku&ids=${vids}`
          }
        })
        .catch(error => {
        })
        .finally(() => {
          this.mode = 'group-creating'
          this.changingMode = false
          this.searchProducts(true, true)
        })
    },

    closeGroupView() {
      this.mode = 'groups-listing'
      this.scanGroups()
    },

    openLink(url) {
      window.open(url)
    },

    debounceSearchProducts: _debounce(function(next = true, refresh = false) {
      this.searchProducts(next,refresh)
    }, 500)
  }

}
</script>
